// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c16235f9","135":"f61452e1","184":"6efa1889","208":"8f5d32da","235":"a00596ed","306":"fa4dd38b","331":"794fecf1","365":"bf2b1207","403":"9e7cb4f2","408":"159e7830","417":"152ae4b5","541":"a0a9266b","893":"6f84ac30"}[chunkId] + ".chunk.js";
};